<script lang="ts" setup>
import { computed, PropType } from "vue";

const props = defineProps({
  /**Ссылка */
  href: { type: String },
  /**Как открывать ссылку */
  target: { type: String as PropType<"_blank" | "_self">, default: "_blank" },
  /**Размер */
  size: { type: Number, default: 3.5 },
});

const tag = computed(() => (props.href ? "a" : "span"));

const svgSize = computed(() => {
  const svgWidth = 41; // Исходная ширина
  const svgHeight = 12; // Исходная высота
  const aspectRatio = svgWidth / svgHeight; // Пропорция ширины к высоте

  // Масштабируем ширину и высоту на основе переданного size
  const scaledWidth = props.size * 0.8;
  const scaledHeight = scaledWidth / aspectRatio;

  return { width: `${scaledWidth}rem`, height: `${scaledHeight}rem` };
});
</script>

<template>
  <component
    class="weeek-tag"
    :is="tag"
    :href="href"
    :target="tag === 'a' ? target : undefined"
    :style="{
      width: `${props.size}rem`,
      height: `${props.size / 2.8}rem`,
    }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="svgSize.width"
      :height="svgSize.height"
      viewBox="0 0 41 12"
      fill="none"
    >
      <path
        d="M21.743 11.1801C18.7622 11.1801 15.7756 11.1801 12.7949 11.1801C11.7522 11.1801 11.01 10.6971 10.5623 9.74869C10.4091 9.42469 10.3502 9.1007 10.3502 8.74725C10.3561 6.81508 10.3149 4.88291 10.362 2.95073C10.3797 2.16726 10.8686 1.5664 11.546 1.15404C11.9407 0.918413 12.3766 0.824158 12.8302 0.824158C18.8094 0.824158 24.7826 0.812379 30.7618 0.830051C32.2168 0.835942 33.2241 1.83148 33.2418 3.31007C33.2712 5.08319 33.2536 6.86221 33.2477 8.63533C33.2418 10.1964 32.0931 11.1919 30.697 11.1801C27.7103 11.1684 24.7237 11.1801 21.743 11.1801ZM21.7665 10.4733C24.7591 10.4733 27.7516 10.4615 30.7441 10.4791C31.775 10.485 32.5349 9.66032 32.5349 8.67656C32.5349 6.90344 32.5408 5.12443 32.529 3.3513C32.529 2.98608 32.4583 2.62085 32.2403 2.30275C31.8692 1.7549 31.3332 1.53105 30.697 1.53105C24.7532 1.52516 18.8035 1.53105 12.8597 1.53105C12.789 1.53105 12.7242 1.53105 12.6535 1.53105C11.7876 1.58407 11.0335 2.32042 11.0394 3.20992C11.0453 5.11264 11.0453 7.01537 11.0453 8.91809C11.0453 9.0359 11.063 9.14194 11.1042 9.25386C11.3399 9.97843 11.982 10.4968 12.9304 10.4909C15.8817 10.4556 18.827 10.4733 21.7665 10.4733Z"
        fill="#6788F3"
      />
      <path
        d="M4.81281 5.39871C4.63609 5.63435 4.59485 5.86408 4.51238 6.08204C4.14715 7.01279 3.79371 7.94942 3.44026 8.88605C3.32245 9.19826 3.12216 9.39855 2.7746 9.41033C2.45061 9.42211 2.21498 9.25128 2.0736 8.88605C1.40205 7.13649 0.730502 5.38693 0.0648446 3.63737C-0.105988 3.18378 0.0707354 2.79499 0.477199 2.6595C0.86599 2.52991 1.21944 2.70663 1.38438 3.13665C1.80263 4.22645 2.21498 5.31624 2.63323 6.40604C2.65679 6.47083 2.68624 6.52974 2.71569 6.59454C2.8394 6.56509 2.83351 6.45905 2.86296 6.38836C3.27532 5.31624 3.68178 4.24412 4.09414 3.172C4.23552 2.80677 4.5006 2.57703 4.79514 2.5947C5.16037 2.61827 5.36654 2.83033 5.49614 3.172C5.88493 4.22056 6.2914 5.26322 6.69197 6.30589C6.72731 6.40603 6.74499 6.51796 6.87459 6.60632C7.07487 6.08793 7.27516 5.57544 7.46955 5.06883C7.71107 4.43852 7.94671 3.80231 8.18823 3.172C8.37084 2.70074 8.73607 2.51223 9.15432 2.67717C9.53133 2.82444 9.6727 3.21912 9.50776 3.66682C8.85978 5.39282 8.21179 7.11882 7.55791 8.84482C7.40475 9.24539 7.1868 9.42211 6.8628 9.42211C6.51525 9.42211 6.2914 9.2395 6.14413 8.83893C5.74945 7.80215 5.36065 6.76537 4.96597 5.7286C4.91885 5.62256 4.87172 5.52831 4.81281 5.39871Z"
        fill="#2E3037"
      />
      <path
        d="M36.0693 5.53485C36.2873 5.41115 36.4405 5.2521 36.5995 5.09305C37.33 4.36848 38.0604 3.63802 38.7909 2.91346C38.9676 2.73673 39.162 2.58357 39.433 2.61303C39.7334 2.64837 39.9749 2.78386 40.081 3.09018C40.187 3.3965 40.0869 3.64981 39.8748 3.86776C39.2386 4.50986 38.6083 5.15195 37.9544 5.77637C37.7423 5.98255 37.7659 6.08859 37.9662 6.28298C38.5965 6.88384 39.2091 7.50826 39.8277 8.1268C40.1575 8.45668 40.1811 8.93383 39.8807 9.22248C39.592 9.50524 39.1797 9.47578 38.838 9.14001C38.1841 8.50381 37.5303 7.8676 36.8823 7.22551C36.7291 7.07235 36.6466 7.07824 36.4758 7.21961C36.1224 7.51415 35.9456 7.84993 36.0163 8.3153C36.0399 8.45079 36.0222 8.59217 36.0163 8.72766C35.9928 9.1459 35.6982 9.42866 35.2918 9.41687C34.9206 9.40509 34.6084 9.10466 34.6084 8.70998C34.6025 7.96185 34.6025 7.21961 34.6025 6.47149C34.6025 5.43471 34.6025 4.39204 34.6025 3.35527C34.6025 2.99593 34.7969 2.74262 35.1091 2.64248C35.386 2.55412 35.7041 2.66015 35.8926 2.90756C35.9987 3.04894 36.0222 3.20799 36.0222 3.37883C36.0222 3.99736 36.0222 4.61589 36.0222 5.23442C36.0222 5.32278 35.9987 5.42293 36.0693 5.53485Z"
        fill="#2E3037"
      />
      <path
        d="M15.1749 2.58074C15.8288 2.58074 16.4886 2.57485 17.1425 2.58074C17.4488 2.58663 17.7433 2.68089 17.8435 2.99899C17.9259 3.25229 17.9613 3.54094 17.7433 3.76479C17.5843 3.92973 17.384 4.02398 17.1425 4.02398C15.817 4.01809 14.4975 4.02399 13.1721 4.01809C12.689 4.01809 12.3827 3.69999 12.4004 3.26408C12.4122 2.87528 12.7538 2.58663 13.2015 2.58074C13.8613 2.58074 14.5152 2.58074 15.1749 2.58074Z"
        fill="#6788F3"
      />
      <path
        d="M29.012 4.00222C28.3581 4.00222 27.6984 4.00222 27.0445 4.00222C26.5968 4.00222 26.2551 3.69001 26.2551 3.30711C26.261 2.88887 26.5909 2.58843 27.0563 2.58254C28.3581 2.57665 29.66 2.57665 30.9677 2.58254C31.4508 2.58254 31.7866 2.89476 31.7807 3.32478C31.7748 3.73714 31.4744 3.99633 30.9854 4.00222C30.3198 4.00222 29.6659 4.00222 29.012 4.00222Z"
        fill="#2E3037"
      />
      <path
        d="M29.0182 7.99481C29.6779 7.99481 30.3318 7.98891 30.9916 7.99481C31.4393 8.0007 31.7692 8.30112 31.7751 8.69581C31.7751 9.09638 31.4511 9.40859 31.0034 9.41448C29.6779 9.42037 28.3525 9.42037 27.033 9.41448C26.5853 9.41448 26.2495 9.09638 26.2495 8.70759C26.2495 8.31291 26.5853 8.0007 27.0271 7.99481C27.6869 7.98891 28.3525 7.99481 29.0182 7.99481Z"
        fill="#2E3037"
      />
      <path
        d="M15.151 7.99219C15.8049 7.99219 16.4647 7.99219 17.1185 7.99219C17.5839 7.99219 17.8843 8.23371 17.8785 8.60483C17.8726 9.15856 17.6487 9.41775 17.1362 9.42365C15.8167 9.42954 14.4913 9.42954 13.1717 9.42365C12.8006 9.42365 12.5061 9.21747 12.4059 8.90526C12.3234 8.65195 12.4589 8.32796 12.7181 8.11C12.8418 8.00397 12.9773 7.99219 13.1246 7.99219C13.802 7.99219 14.4795 7.99219 15.151 7.99219Z"
        fill="#6788F3"
      />
      <path
        d="M22.1199 9.41628C21.4307 9.41628 20.7474 9.42217 20.0582 9.41039C19.6988 9.4045 19.3984 9.13352 19.3571 8.81542C19.31 8.46787 19.4867 8.14977 19.8048 8.04373C19.905 8.00839 20.0169 7.99661 20.123 7.99661C21.4366 7.99071 22.7502 7.99071 24.0698 7.99661C24.5764 7.99661 24.8415 8.26169 24.8356 8.72117C24.8297 9.1512 24.5469 9.41039 24.0639 9.41628C23.4159 9.42217 22.7679 9.41628 22.1199 9.41628Z"
        fill="#2E3037"
      />
      <path
        d="M22.0963 3.99453C21.4307 3.99453 20.765 3.99453 20.0935 3.99453C19.6281 3.99453 19.3453 3.73534 19.3394 3.31709C19.3335 2.89295 19.6399 2.58074 20.0817 2.58074C21.4071 2.57485 22.7325 2.58074 24.0521 2.58074C24.3702 2.58074 24.6058 2.71623 24.7531 2.9872C24.8768 3.22284 24.8473 3.46436 24.7118 3.68821C24.5763 3.90617 24.3819 4.00631 24.1227 4.00631C23.4512 3.98864 22.7738 3.99453 22.0963 3.99453Z"
        fill="#2E3037"
      />
      <path
        d="M14.6742 6.70751C14.1853 6.70751 13.6904 6.7134 13.2015 6.70751C12.7479 6.70162 12.4062 6.41297 12.4062 6.03007C12.4062 5.55881 12.7067 5.27606 13.2074 5.27606C14.1794 5.27606 15.1514 5.27016 16.1233 5.27606C16.7949 5.27606 17.0835 5.83568 16.8832 6.27749C16.7478 6.56614 16.5121 6.68984 16.2058 6.70751C16.1881 6.70751 16.1646 6.70751 16.1469 6.70751C15.658 6.70751 15.169 6.70751 14.6742 6.70751Z"
        fill="#6788F3"
      />
      <path
        d="M21.6017 6.69945C21.101 6.69945 20.6003 6.70535 20.0996 6.69945C19.6283 6.69356 19.3397 6.41081 19.3455 5.98078C19.3514 5.58021 19.6578 5.28567 20.0996 5.28567C21.101 5.27978 22.1024 5.27978 23.098 5.28567C23.5516 5.28567 23.8579 5.59199 23.8579 6.01024C23.8579 6.39903 23.5339 6.69356 23.098 6.69945C22.6031 6.69945 22.1024 6.69945 21.6017 6.69945Z"
        fill="#2E3037"
      />
      <path
        d="M28.4819 6.69945C27.993 6.69945 27.4981 6.70535 27.0092 6.69945C26.5851 6.69356 26.2434 6.37546 26.2434 6.01024C26.2434 5.60966 26.5733 5.28567 27.0151 5.28567C28.0165 5.27978 29.018 5.27978 30.0194 5.28567C30.4553 5.28567 30.7734 5.59199 30.7793 5.98667C30.7852 6.39314 30.4671 6.69946 30.0135 6.70535C29.501 6.70535 28.9885 6.69945 28.4819 6.69945Z"
        fill="#2E3037"
      />
    </svg>
  </component>
</template>

<style lang="scss" scoped>
.weeek-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #dde5ff;
  border: 0.063rem solid #6788f3;
  border-radius: 1.063rem;
}

a.weeek-tag {
  cursor: pointer;
}
</style>
